import { AfterViewInit, ChangeDetectionStrategy, Component, inject, input, signal, ViewChild, ElementRef } from '@angular/core';
import { FeedItem } from '@core/models';
import { MediaViewComponent } from '@modules/media/media-view/media-view.component';
import { FeedNavComponent } from '@shared/components/media-swiper/components/feed-nav/feed-nav.component';
import { HeaderComponent, IconComponent } from '@shared/components';
import { MediaActionsMode } from '@core/models';
import { BreakpointFacade } from '@core/facades';
import { MediaSwiperFacade } from '@shared/components/media-swiper/media-swiper.facade';
import { GoBackDirective } from '@shared/directives/go-back.directive';
import { RippleDirective } from '@shared/directives';
import { TopButtonComponent } from '@shared/components/media-swiper/components/top-button/top-button.component';
import { AnalyticsService } from '@core/services/analytics/analytics.service';
import { AnalyticsEventsEnum } from '@core/models/analytics.model';
import { mediaActions, mediaSelectors } from '@store/media';
import { Store } from '@ngrx/store';

@Component({
  selector: 'cheelee-media-list',
  standalone: true,
  imports: [
    MediaViewComponent,
    FeedNavComponent,
    HeaderComponent,
    GoBackDirective,
    RippleDirective,
    IconComponent,
    TopButtonComponent,
  ],
  templateUrl: './media-list.component.html',
  styleUrl: './media-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MediaSwiperFacade],
})
export class MediaListComponent implements AfterViewInit {

  @ViewChild('feedElementRef', { static: true })
  public target!: ElementRef<HTMLElement>;

  public feed = input.required<FeedItem[]>();

  private readonly store = inject(Store);

  private readonly breakpointFacade = inject(BreakpointFacade);

  private readonly mediaSwiperFacade = inject(MediaSwiperFacade);

  public readonly analyticsEvents = AnalyticsEventsEnum;

  protected isMobile = this.breakpointFacade.isMobile;

  protected isDesktop = this.breakpointFacade.isDesktop;

  public readonly isMuted = this.store.selectSignal(mediaSelectors.selectIsMuted);

  public mode = input<MediaActionsMode>(MediaActionsMode.RECOMMENDATIONS);

  public readonly currentIndex = signal(0);

  public readonly isLoading = this.mediaSwiperFacade.isLoading;

  public canPrev = signal(false);

  public ngAfterViewInit() {
    
  }

  public toggleMute(force = false) {
    this.store.dispatch(mediaActions.muteMedia({ isMuted: force || !this.isMuted() }));
  }

  onScroll(scrollPosition: Event) {
    const el = (scrollPosition.target as HTMLElement);
    this.canPrev.set(this.target.nativeElement.scrollTop > 100);
    if (el.scrollTop > el.scrollHeight - ( el.getBoundingClientRect().height * 10)) {
      if (!this.isLoading() && this.mode() !== 'single') {
        this.mediaSwiperFacade.getNextFeedMedia();
      }

      // if (!this.fapsStore.isLoading()) {
      //   const queryParams = this.queryParams();
      //   if (queryParams) {
      //     this.fapsStore.loadByQuery({
      //       ...queryParams,  p: this.fapsStore.nextPage(),
      //     });
      //   } else {
      //     this.fapsStore.loadByQuery({ p: this.fapsStore.nextPage() });
      //   }
      //
      // }
    }
  }

  public onPrevSlide(): void {
    const target = this.target.nativeElement;
    this.target.nativeElement.scrollTo({ top: target.scrollTop - target.clientHeight });
  }

  public onNextSlide(): void {
    const target = this.target.nativeElement;
    this.target.nativeElement.scrollTo({ top: target.scrollTop + target.clientHeight });
  }


  protected readonly MediaActionsMode = MediaActionsMode;
}
